export enum ReportStatus {
    Closed = 'Closed',
    In_Progress = 'In Progress',
    Unresolved = 'Unresolved',
    Urgent = 'Urgent',
    Scheduled = 'Scheduled'
}
